import EditManageOptions from '../pages/admin/qr-teams/edit-manage-options'
export default EditManageOptions
